<template>
    <div>
        <Row style="margin-bottom: 10px" type="flex" justify="end">
            <Col  style="margin-right: 18px;">
                <Input class="search-keyword" style="width: 110%;" v-model="table.page.keyword" search
                       :placeholder="$t('l.remark70')"  @on-search="loadData(1)"/>
                <Input hidden style="display:none"/>
            </Col>
        </Row>
        <Table :columns="getColumns" :loading="table.loading" :data="table.data">
            <template slot-scope="{ row, index }" slot="action">
                <i-switch :value="bindIds.includes(row.id)" :ref="'switch_'+index" @on-change="onBindChange($event, row.id, 'switch_'+index)">
                </i-switch>
            </template>
        </Table>
        <Page size="small" :current="table.page.current"
              :page-size="table.page.size"
              :total="table.page.total"
              :page-size-opts="table.page.sizeOptions"
              show-elevator show-sizer show-total
              @on-page-size-change="($event)=>{table.page.size = $event,loadData(1)}"
              @on-change="loadData($event)"></Page>
    </div>
</template>

<script>
    import util from '../../../libs/util';
    export default {
        name: "demo-bind-device",
        props: {
            departId: Number,
            bindIds: {
                type: Array,
                default: ()=>{}
            }
        },
        data () {
            return {
                table: {
                    data: [],
                    loading:false,
                    page: {
                        current: 1,  // 当前页码
                        size: 10, // 每页个数
                        sizeOptions: [10],
                        total: 0,
                        sortKey: 'id',
                        sortMethod: 'desc',
                        keyword:''
                    },
                },
            }
        },
        computed:{
            getColumns(){
                return [
                    {
                        title: 'ID',
                        align: 'center',
                        width: 100,
                        key: 'id'
                    },
                    {
                        title: this.$t('l.job_num'),
                        align: 'left',
                        key: 'code',
                    },
                    {
                        title: this.$t('l.terminal_id'),
                        align: 'left',
                        key: 'terminal_id',
                    },
                    {
                        title:  this.$t('l.lift_name'),
                        align: 'left',
                        key: 'name'
                    },
                    {
                        title: this.$t('l.community'),
                        align: 'left',
                        key: 'community_name',
                    },
                    {
                        title: this.$t('l.install_location'),
                        align: 'left',
                        render: (h, params) => {
                            let emptyObj = {name: ''};
                            let location = util.parseJSON(params.row.j_location, {});
                            location.building = location.building || emptyObj;
                            location.unit = location.unit || emptyObj;
                            location.door = location.door || emptyObj;
                            return h('span', [location.building.name + ' ' + location.unit.name + ' ' + location.door.name ]);
                        }
                    },
                    {
                        title: this.$t('l.binding'),
                        slot: 'action',
                        align: 'center'
                    }
                ]
            }
        },
        watch: {
            departId: {
                handler (newId) {

                },
                immediate: true
            }
        },
        methods: {
            loadData (page) {
                let params = {
                    page: page || this.table.page.current,
                    size: this.table.page.size,
                    orderKey: this.table.page.sortKey,
                    orderMethod: this.table.page.sortMethod,
                    noStatus: true,
                    keyword: this.table.page.keyword,
                };
                this.table.loading = true;
                util.ajax.post('/device/list', params).then(res => {
                this.table.loading = false;
                    this.setPage(res.data);
                })
            },
            setPage(pageInfo) {
                this.table.data = pageInfo.list;
                this.table.page.current = pageInfo.pageNumber;
                this.table.page.total = pageInfo.totalRow;
            },
            onBindChange (value, deviceId, vm) {
                util.ajax.put('/depart/binddevice', {
                    depart: this.departId,
                    device: deviceId,
                    bind: value
                }).then(res => {
                    this.$Message.success(`${value?this.$t('l.binding'):this.$t('l.cancel_binding_suc')}`)
                    if (value) this.bindIds.push(deviceId);
                    else this.bindIds.splice(this.bindIds.indexOf(deviceId), 1);
                }).catch(e => {
                    this.$refs[vm].currentValue = !value;
                })

            }
        },
        mounted () {
            this.loadData();
        }
    }
</script>

<style scoped>

</style>